import React from 'react';
import { Link } from 'react-router-dom';
import { CoinsIcon, GemIcon, FileLockIcon, PaletteIcon, WatchIcon, CarFrontIcon, UserRoundCheckIcon, ShieldCheckIcon, SnowflakeIcon, EyeIcon, BadgeCheckIcon } from 'lucide-react';
const CONVOY_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/f8b3de46-2dc0-4ad9-b4aa-18e7bb07d6a4.jpg';
const GUARD_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/4b7f5ce9-ed19-4da6-8767-73c3900a6692.jpg';
const items = [{
  icon: CoinsIcon,
  title: 'Precious Metals',
  desc: 'Gold, silver, platinum and palladium — bullion bars and coins stored in segregated, insured vaults.'
}, {
  icon: GemIcon,
  title: 'Jewelry & Gemstones',
  desc: 'Certified diamonds, gemstones and fine jewelry under dual-custody handling protocols.'
}, {
  icon: WatchIcon,
  title: 'Luxury Watches',
  desc: 'Collectible and investment-grade timepieces stored in climate-stable conditions.'
}, {
  icon: PaletteIcon,
  title: 'Fine Art',
  desc: 'Paintings, sculpture and collectibles held in humidity-controlled, monitored chambers.'
}, {
  icon: FileLockIcon,
  title: 'Documents & Deeds',
  desc: 'Legal documents, certificates and deeds in tamper-evident, sealed safekeeping.'
}, {
  icon: CarFrontIcon,
  title: 'Escort & Convoy',
  desc: 'Coordinated security escort and convoy services for executives, assets and high-priority movement.'
}, {
  icon: UserRoundCheckIcon,
  title: 'Security Guards',
  desc: 'Professional guard coverage for residences, offices, sites, events and commercial properties.'
}];
const guarantees = [{
  icon: ShieldCheckIcon,
  title: 'Dual-custody protocol',
  desc: 'No single individual can access a client holding alone — every movement requires two authorized signatures.'
}, {
  icon: SnowflakeIcon,
  title: 'Climate-controlled vaults',
  desc: 'Temperature and humidity regulated to preserve metals, art and documents indefinitely.'
}, {
  icon: EyeIcon,
  title: '24/7 monitoring',
  desc: 'Continuous surveillance, intrusion detection and on-site security across every facility.'
}, {
  icon: BadgeCheckIcon,
  title: 'Verifiable SKRs',
  desc: 'Every deposit is backed by a unique Safe Keeping Receipt you can confirm online any time.'
}];
export function Services() {
  return <div className="w-full bg-white" data-id="element-298" data-mp="1ldzfcma291ji">
      <section className="bg-steca-50" data-id="element-299" data-mp="1hbb4ya5p7mkf">
        <div className="mx-auto max-w-6xl px-4 py-16 text-center sm:px-6" data-id="element-300" data-mp="1ha9tw5oon02p">
          <h1 className="font-display text-4xl font-extrabold text-steca-ink" data-id="element-301" data-mp="1vaawbpklifka">Our Services</h1>
          <p className="mx-auto mt-3 max-w-2xl text-steca-ink/70" data-id="element-302" data-mp="1qc9d94n66g8t">
            From Kinondoni, Dar es Salaam, Steca Global Security delivers high-security safekeeping,
            trained guard coverage, and dependable escort and convoy protection.
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6" data-id="element-303" data-mp="2e129713sko3f">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-304" data-mp="2dz943q8tubxj">
          {items.map(it => <div key={it.title} className="rounded-2xl border border-steca-100 bg-white p-6 shadow-sm" data-id="element-305" data-mp="2905ya3l0w1oi">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-steca-50 text-steca-600" data-id="element-306" data-mp="2sm7sfcce0q81">
                <it.icon className="h-5 w-5" data-id="element-307" data-mp="2jncl1wxlxa35" />
              </div>
              <h2 className="mt-4 font-display text-lg font-bold text-steca-ink" data-id="element-308" data-mp="2jn2vgagh54xz">{it.title}</h2>
              <p className="mt-2 text-sm text-steca-ink/70" data-id="element-309" data-mp="2nn4lfmcuk9xf">{it.desc}</p>
            </div>)}
        </div>
      </section>
      <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6" data-id="element-310" data-mp="2eo9e26y2gtsj">
        <div className="grid gap-6 lg:grid-cols-2" data-id="element-311" data-mp="2epuci7ni4wvo">
          <article className="overflow-hidden rounded-2xl bg-steca-900 text-white shadow-sm" data-id="element-312" data-mp="1zzvec4vy5lg7">
            <img src={CONVOY_IMG} alt="Professional security convoy operating in Dar es Salaam" className="h-64 w-full object-cover" data-id="element-313" data-mp="24y6lu8yrrjv9" />
            <div className="p-6" data-id="element-314" data-mp="1qzzw5g3z4q6o">
              <div className="flex items-center gap-2 text-steca-300" data-id="element-315" data-mp="1r119jr8gpork"><CarFrontIcon className="h-5 w-5" data-id="element-316" data-mp="1vwqde6rilrto" /><span className="text-sm font-semibold uppercase tracking-wide" data-id="element-317" data-mp="1vzuntlvkpjss">Movement security</span></div>
              <h2 className="mt-3 font-display text-2xl font-extrabold" data-id="element-318" data-mp="1nywths6io0pe">Escort &amp; convoy protection</h2>
              <p className="mt-3 text-sm leading-relaxed text-steca-100/80" data-id="element-319" data-mp="1e797i6sqbbvb">Carefully coordinated route protection for executive travel, sensitive cargo, and special events — managed by trained professionals.</p>
            </div>
          </article>
          <article className="overflow-hidden rounded-2xl border border-steca-100 bg-white shadow-sm" data-id="element-320" data-mp="157m79obqkc3u">
            <img src={GUARD_IMG} alt="Professional security guard on duty" className="h-64 w-full object-cover" data-id="element-321" data-mp="106q3dardwpyf" />
            <div className="p-6" data-id="element-322" data-mp="v8wto7qvhdte">
              <div className="flex items-center gap-2 text-steca-600" data-id="element-323" data-mp="r6t98tm86yvz"><UserRoundCheckIcon className="h-5 w-5" data-id="element-324" data-mp="r8e2mfwt0bs9" /><span className="text-sm font-semibold uppercase tracking-wide" data-id="element-325" data-mp="2pmfoh9tiqib0">On-site security</span></div>
              <h2 className="mt-3 font-display text-2xl font-extrabold text-steca-ink" data-id="element-326" data-mp="2ll3w4wj9fiz4">Security guards you can trust</h2>
              <p className="mt-3 text-sm leading-relaxed text-steca-ink/70" data-id="element-327" data-mp="7duxnxfbq0ve">Professional presence and tailored guard deployments for homes, businesses, construction sites and events.</p>
            </div>
          </article>
        </div>
      </section>
      <section className="bg-steca-50" data-id="element-328" data-mp="h4zaaqhj19n2">
        <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6" data-id="element-329" data-mp="l4zoca0pritl">
          <h2 className="text-center font-display text-3xl font-extrabold text-steca-ink" data-id="element-330" data-mp="l6aswc1zgulr">
            Security you can rely on
          </h2>
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-331" data-mp="3phwjwri18m3j">
            {guarantees.map(g => <div key={g.title} className="text-center" data-id="element-332" data-mp="3tji28sdc5sl4">
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-steca-600 text-white" data-id="element-333" data-mp="2dqf81uuuw2j">
                  <g.icon className="h-6 w-6" data-id="element-334" data-mp="18utyukxk8vao" />
                </div>
                <h3 className="mt-4 font-display font-bold text-steca-ink" data-id="element-335" data-mp="1dt58ovnuv5sw">{g.title}</h3>
                <p className="mt-2 text-sm text-steca-ink/70" data-id="element-336" data-mp="1duyl6rl5gk8t">{g.desc}</p>
              </div>)}
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-6xl px-4 py-16 text-center sm:px-6" data-id="element-337" data-mp="35tn6q5ynbt3m">
        <h2 className="font-display text-2xl font-extrabold text-steca-ink" data-id="element-338" data-mp="3juzis6aorak8">
          Already have a Safe Keeping Receipt?
        </h2>
        <Link to="/verify" className="mt-5 inline-flex items-center gap-2 rounded-xl bg-steca-600 px-6 py-3 font-semibold text-white transition-colors hover:bg-steca-700" data-id="element-339" data-mp="3evwfaqactced">
          <BadgeCheckIcon className="h-5 w-5" data-id="element-340" data-mp="2m8achk8yabsk" />
          Confirm your SKR
        </Link>
      </section>
    </div>;
}